import { LitElement, html, nothing } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { CategoriesList } from '../../../incidentsGrid/types';
import _ from 'lodash';

/**
 * @summary Type here the description of this component
 * @tag show-more-items
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('show-more-items-in-bulk')
export class ShowMoreItemsInBulkWebComponent extends LitElement {
  /**
   * See https://lit-element.polymer-project.org/guide/properties
   * Write here the description of this field
   */
  @property({
    type: Array,
    attribute: false,
    reflect: false,
  })
  _initialItems;

  @property({
    type: String,
    attribute: false,
    reflect: false,
  })
  title;

  @state()
  isShowMorePresent = true;

  @state()
  displayedItems;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  @property({
    type: String,
    attribute: false,
  })
  showMoreButtonText;

  @property({
    type: Number,
    attribute: false,
  })
  itemsBulkSize = 5;

  @state()
  currentBatchIndex = 0;

  render() {
    return html`
      ${this.displayedItems.map(item => {
        return item;
      })}
      ${this.isShowMorePresent
        ? html`
            <gz-link @click="${e => this.handleShowMoreClick(e)}">
              <gz-text fontSize="${FontSizes.PARAGRAPH_11}" fontWeight="${FontWeights.NORMAL}"
                >${this.showMoreButtonText}
              </gz-text>
            </gz-link>
          `
        : nothing}
    `;
  }

  get items(): Array<CategoriesList> {
    return this._initialItems;
  }

  /**
   * array of categories to be rendered in a list
   */
  set items(prop: Array<CategoriesList>) {
    const oldItems = this._initialItems;
    this._initialItems = prop;

    if (this._initialItems.length > this.itemsBulkSize) {
      this.isShowMorePresent = true;
      this.displayedItems = this._initialItems.slice(0, this.itemsBulkSize);
      this.currentBatchIndex = this.displayedItems.length;
    } else {
      this.displayedItems = _.clone(this._initialItems);
      this.isShowMorePresent = false;
    }

    this.requestUpdate('items', oldItems);
  }

  handleShowMoreClick(e) {
    const nextBatchIndex = this.currentBatchIndex + this.itemsBulkSize;

    if (this._initialItems.length > nextBatchIndex) {
      this.isShowMorePresent = true;
      this.displayedItems = this._initialItems.slice(0, nextBatchIndex);
      this.currentBatchIndex = this.displayedItems.length;
    } else {
      this.displayedItems = _.clone(this._initialItems);
      this.isShowMorePresent = false;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'show-more-items-in-bulk': ShowMoreItemsInBulkWebComponent;
  }
}
